import CompressorPart from './CompressorPart.js';
import Dropdown from 'react-dropdown'
import React, { Component } from 'react';

const LOW = 'LOW';
const MID = 'MID';
const HIGH = 'HIGH';

class MultibandCompressorEffect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPart: LOW
        };
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    onSelectCompressor(o) {
        o = o.value;
        this.setState({
            selectedPart: o
        });
    }

    getCompressor() {
        return this.props.effect.compressors.find(
            c => c.name === this.state.selectedPart);
    }

    render() {
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                      <div className="osc-type-dropdown-container">
                            <Dropdown
                                  className='osc-type-dropdown'
                                  controlClassName='osc-type-control-dropdown'
                                  arrowClassName='osc-type-arrow-dropdown'
                                  options={OPTIONS}
                                  onChange={(o) => this.onSelectCompressor(o)}
                                  value={getOption(this.state.selectedPart)}
                                  placeholder="LFO" />
                          </div>
                          <CompressorPart
                                selectedParameter={this.props.selectedParameter}
                                automation={this.props.automation}
                                sequencerEngine={this.props.sequencerEngine}
                                onParameterChanged={this.props.onParameterChanged}
                                effect={this.getCompressor()}
                                effectNumber={this.props.effectNumber}
                                />
                </div>} 
            </div>
        );
    }
}

const OPTIONS = [
    {
        value: "LOW",
        label: "Low",
    },
    {
        value: "MID",
        label: "Mid",
    },
    {
        value: "HIGH",
        label: "High",
    }
];

function getOption(value) {
        for (var i=0; i < OPTIONS.length; i++) {
            if (OPTIONS[i].value == value) {
                return OPTIONS[i];
            }
        }
        return null;
    }


export default MultibandCompressorEffect;
